export default () => ({
    root: {
        display: 'flex',
        flexFlow: 'column nowrap',
        height: '100%',
        boxSizing: 'border-box',
    },
    chatContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: 16,
        padding: '16px 16px 8px 16px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        minHeight: 0,
    },
    chat: {
        flex: 1,
        padding: 0,
        maxHeight: 'calc(100% - 42px)',
    },
    chatFooter: {
        padding: 16,
    },
    chatFooterLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        cursor: 'pointer',
        marginLeft: 4,
    },
});
